import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotifyComponent } from './components/notify/notify.component';
import { AddPunctuationPipe } from './pipes/add-punctuation.pipe';
import { CorePipesModule } from '@fleet-beat/libs-core/src/lib/pipes/core-pipes.module';

@NgModule({
  imports: [CommonModule, MatSnackBarModule, MatButtonModule, MatIconModule, CorePipesModule],
  declarations: [NotifyComponent, AddPunctuationPipe],
  entryComponents: [NotifyComponent],
  exports: [NotifyComponent],
})
export class SnackbarModule {}
